import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _excluded = ["choices"],
  _excluded2 = ["choices"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable max-classes-per-file,@typescript-eslint/no-unsafe-declaration-merging */

export function Field(defaultValueOfType) {
  var FieldHost = /*#__PURE__*/function () {
    function FieldHost(_ref) {
      var alias = _ref.alias,
        name = _ref.name,
        defaultValue = _ref.default,
        required = _ref.required,
        description = _ref.description;
      _classCallCheck(this, FieldHost);
      this.alias = alias;
      this.name = name;
      this.default = typeof defaultValue !== 'undefined' ? defaultValue : defaultValueOfType;
      this.required = required;
      this.description = description;
    }
    _createClass(FieldHost, [{
      key: "isNodeField",
      value: function isNodeField() {
        return false;
      }
    }]);
    return FieldHost;
  }();
  return FieldHost;
}
export var ChildrenField = /*#__PURE__*/function (_Field) {
  _inherits(ChildrenField, _Field);
  var _super = _createSuper(ChildrenField);
  function ChildrenField() {
    _classCallCheck(this, ChildrenField);
    return _super.apply(this, arguments);
  }
  _createClass(ChildrenField, [{
    key: "isNodeField",
    value: function isNodeField() {
      return true;
    }
  }]);
  return ChildrenField;
}(Field([]));
export var BooleanField = /*#__PURE__*/function (_Field2) {
  _inherits(BooleanField, _Field2);
  var _super2 = _createSuper(BooleanField);
  function BooleanField() {
    _classCallCheck(this, BooleanField);
    return _super2.apply(this, arguments);
  }
  return _createClass(BooleanField);
}(Field(undefined));
export var NumberField = /*#__PURE__*/function (_Field3) {
  _inherits(NumberField, _Field3);
  var _super3 = _createSuper(NumberField);
  function NumberField() {
    _classCallCheck(this, NumberField);
    return _super3.apply(this, arguments);
  }
  return _createClass(NumberField);
}(Field(undefined));
export var AnyField = /*#__PURE__*/function (_Field4) {
  _inherits(AnyField, _Field4);
  var _super4 = _createSuper(AnyField);
  function AnyField() {
    _classCallCheck(this, AnyField);
    return _super4.apply(this, arguments);
  }
  return _createClass(AnyField);
}(Field(undefined));
export var ChoiceField = /*#__PURE__*/function (_Field5) {
  _inherits(ChoiceField, _Field5);
  var _super5 = _createSuper(ChoiceField);
  function ChoiceField(_ref2) {
    var _this;
    var choices = _ref2.choices,
      field = _objectWithoutProperties(_ref2, _excluded);
    _classCallCheck(this, ChoiceField);
    _this = _super5.call(this, field);
    _this.choices = choices;
    return _this;
  }
  return _createClass(ChoiceField);
}(Field(undefined));
export var StringField = /*#__PURE__*/function (_Field6) {
  _inherits(StringField, _Field6);
  var _super6 = _createSuper(StringField);
  function StringField(_ref3) {
    var _this2;
    var choices = _ref3.choices,
      field = _objectWithoutProperties(_ref3, _excluded2);
    _classCallCheck(this, StringField);
    _this2 = _super6.call(this, field);
    _this2.choices = choices;
    return _this2;
  }
  return _createClass(StringField);
}(Field(undefined));
export var TextField = /*#__PURE__*/function (_Field7) {
  _inherits(TextField, _Field7);
  var _super7 = _createSuper(TextField);
  function TextField() {
    _classCallCheck(this, TextField);
    return _super7.apply(this, arguments);
  }
  return _createClass(TextField);
}(Field(undefined));